<template>
  <img
    v-if="img?.sizes?.length"
    :key="currLocale"
    class="lazy"
    :width="img.width"
    :height="img.height"
    :src="gensvg"
    :data-src="img.url"
    :data-srcset="srcset"
    :data-sizes="sizes"
    :alt="img.alt"
    :sizes="sizes"
  />
</template>

<script>
export default {
  props: ['img', 'sizes', 'superlazy', 'class'],
  computed: {
    gensvg() {
      return this.img.sizes[0].src;
    },
    srcset() {
      var sizesString = '';
      for (var i = 0; i < this.img.sizes.length; i++) {
        sizesString +=
          this.img.sizes[i].src +
          ' ' +
          this.img.sizes[i].width +
          'w' +
          (i < this.img.sizes.length - 1 ? ', ' : '');
      }
      return sizesString;
    },
    showImage() {
      if (!this.img) return false;
      if (typeof this.img != 'object') return false;
      if ((!'sizes') in this.img) return false;
      return true;
    }
  },
  methods: {
    updateLazy() {
      this.$nextTick(() => {
        this.$store.state.lazy.update();
      });
    }
  },
  mounted() {
    if (this.superlazy != true) this.updateLazy();
  },
  watch: {
    superlazy: {
      handler() {
        if (this.superlazy != true) this.updateLazy();
      },
      immediate: true
    },
    img: {
      deep: true,
      immediate: true,
      handler() {
        this.updateLazy();
      }
    },
    currLocale: {
      deep: true,
      immediate: true,
      handler() {
        this.updateLazy();
      }
    }
  }
};
</script>
